"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineConfig = void 0;
const getOrderLineConfig = (config, type) => {
    switch (type) {
        case "GOLF": {
            return config;
        }
        case "HOTEL": {
            return config;
        }
        case "TRANSFER": {
            return config;
        }
        case "EXCURSION": {
            return config;
        }
        case "CUSTOM": {
            return config;
        }
    }
};
exports.getOrderLineConfig = getOrderLineConfig;
